module.exports = __webpack_public_path__ + "img/user_guide_arrow.93975185.png";